<template>
    <div class="privacy-wrapper">
        <div class="content">
            <div class="main">
                <div class="introduce-content">{{ title }}</div>
                <div class="tips">{{ }}</div>
            </div>
        </div>
        <div v-html="detail" class="info main">

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
			partner_id:0,
			goto:'plan',
            title: '',
            detail: '',
            id: '',
            config: {
                1: {
                    title: 'TERMS OF USE',
                    tips: '使用條款'
                },
                2: {
                    title: 'PRIVACY POLICY',
                    tips: '私隱政策'
                }
            }
        }
    },

    created() {
		
		//this.partner_id = this.$getStorage('partner_id')

		if (this.$route.query.partner_id) {
		    this.partner_id = this.$route.query.partner_id
			this.$setStorage('partner_id', this.partner_id)
		}
		
		
		if (this.$route.query.goto) {
		    this.goto = this.$route.query.goto
			 
		}
		this.$router.push({ path: this.goto })
    },

    methods: {
        async getDetail() {
            let fdata = { do: 'json', sjk: 'frontlist', searchkey: 'id', searchvalue: this.id || 16, }
            let res = await this.$api.funk(fdata)
            if (res && res.length) {
                this.title = res[0].title
                this.detail = res[0].detail
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.privacy-wrapper {
    .info {
        padding: 0.8rem 0;
        font-size: 0.24rem;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        line-height: 0.34rem;
        color: #000000;
    }

    .content {
        width: 100%;
        height: 3.4rem;
        background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;
        position: relative;

        .left {
            width: 4.53rem;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }

        .main {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            flex-direction: column;
        }


        .right {
            width: 4.53rem;
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }

        .introduce-content {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 600;
            font-size: 0.64rem;
            line-height: 0.64rem;
            color: #000000;
            text-align: center;

            span {
                color: #E02E43;
            }
        }

        .tips {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.34rem;
            text-align: center;
            color: #000000;
            margin-top: 0.16rem;
        }
    }
}

@media (max-width: 750px) {
    .privacy-wrapper .info {
        padding: 0.8rem 0.3rem;
        font-size: 0.3rem;
        line-height: 0.4rem;
    }
}
</style>